import moment from 'moment';

export const GenerateDate = (date) => {
    if(moment(date).isValid() === true){ return  moment(date).format('Do MMM yyyy');}
    else return '-'
};
export const GenerateDateandTime = (date) => {
    if(moment(date).isValid() === true){ return moment.unix(date).format('Do MMM yyyy');}
    else return '-'
};
export const GenerateDateFormat = (date) => {
    if(moment(date).isValid() === true){ return moment(date).format('DD/MM/YYYY');}
    else return '-'
};

export const ExpectedDateGenerator = (type) => {
    let expectedDate='';
    if(type==='A'){
        expectedDate = moment().add(10, 'days');
    }else if(type==='B'){
        expectedDate = moment().add(21, 'days')

    }else if(type==='C'){
        expectedDate = moment().add(45, 'days');

    }
    return GenerateDateFormat(expectedDate)
};

export const generateDateWithTime = (date) => {
    if(moment.unix(date).isValid() === true){ return  moment.unix(date).format('DD-MMM-YYYY HH:mm:ss')}
    else return '-'
}